import { Box, Flex } from 'components/Box'
import Container from 'components/layout/Container';
import styled from 'styled-components';
import HeroBG from 'assets/Hero/HeroBG-1.svg';
import FormBtn from 'assets/Buttons/FormBtn.svg';
import RemoteImg from 'assets/Hero/RemoteImg.svg';
import HeroBackgroundWrapper from 'assets/Hero/HeroBackground.svg';
import HeroBackgroundBody from 'assets/Hero/HeroBG-1.svg';
import { Text } from 'components/Text';

export const LoginBackgroundImage = styled(Flex)`
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;  
   
    ${({ theme }) => theme.mediaQueries.xs} {
        margin-bottom: 0px;
        background-image: none;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        background-image: url("./assets/banner/image_2021_12_31T09_34_28_192Z.png");
    }
`
export const LoginBackgroundFormBox = styled(Flex)`
    background: ${(props) => props.theme.colors.text};
    margin: auto;

    ${({ theme }) => theme.mediaQueries.xs} {
        height: 700px;
        border-radius: 20px 20px 0px 0px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 600px;
        height: 865px;
        border-radius: 20px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        height: 741px;
    } 
`

export const ContainerPaddingMargin = styled(Container)`
    
    ${({ theme }) => theme.mediaQueries.xs} {
        margin: 0;
        padding: 0;
        width: 100%;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 100px auto 20px auto;
        padding: 16px;
`
export const ContainerPaddingMarginForgotPage = styled(Container)`
    ${({ theme }) => theme.mediaQueries.xs} {
        margin: 0;
        padding: 0;
        width: 100%;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 23vh auto;
        padding: 16px;
`

export const LoginFormStyle = styled(Box)`
    margin: auto;

    ${({ theme }) => theme.mediaQueries.xs} {
        width: 90%;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        width: 90%;
    }
`

export const Forgotlink = styled(Box)`
    & button{
        all: unset;
        color: #000;
        text-decoration: none;
        float: right;
        margin: 0px 0px 45px 0px;
        font-weight: 400;
        font-size: 16px;
        cursor: pointer;
        :hover{
            color: ${(props) => props.theme.colors.primary};
        }
    }
`
export const FormSubmitBtn = styled(Box)`
    & Button{
        all: unset;
        width: 100%;
        height: 60px;
        background-image: url("newAssets/Buttons/ForgotBtn.png");
        font-size: ${'18px'};
        color: ${(props) => props.theme.colors.text};
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        margin: 50px 0px 30px 0px;
    }
`
export const InputFieldStyle = styled(Box)`
    margin: 20px 0;
    
    & a{
        text-decoration: none;
        color: #001FFF;

        :hover{
            color:  ${(props) => props.theme.colors.primary};
        }

        ${({ theme }) => theme.mediaQueries.xs} {
            display: flex;
            justify-content: end;
        }
        ${({ theme }) => theme.mediaQueries.sm} {
            display: flex;
            justify-content: start;
        }
    }
    & label{
        color: ${(props) => props.theme.colors.textSubtle};
        margin: 10px 0px;
        font-weight: 500;
        font-size: 16px;
    }
    & img{
        width: 35px;
        height: 35px;
    }
    & input{
        height: 60px;
        background: ${(props) => props.theme.colors.inputBackground};
        border-radius: 0px;
        border: none;
        ${({ theme }) => theme.mediaQueries.xs} {
            width: 100%;
        }
        ${({ theme }) => theme.mediaQueries.sm} {
            width: 532px;
        }
    }
    .form-control:focus{
        color: ${(props) => props.theme.colors.textSubtle};
        background: ${(props) => props.theme.colors.imgBackgroundColor};
        border-color: none;
        outline: 0;
        box-shadow: none;
    }
    .ForgotModelInputWidth{
        width: 100%;
    }

    ${Flex}{
        ${({ theme }) => theme.mediaQueries.xs} {
        }
        ${({ theme }) => theme.mediaQueries.sm} {
            width:50%;
        }
    }
`

export const NeedAnAccount = styled(Flex)`   
    margin: 10px 0px;
    justify-content: center;
    align-items: center;

    & a{
        color: ${(props) => props.theme.colors.primary};
        text-decoration:none;
        font-weight: bold;

        :hover{
            color:  ${(props) => props.theme.colors.textSubtle};
        }
    }
`

export const FormHeading = styled(Box)`
    text-align: center;
    margin: 20px 0px;
`
export const FormRightBox = styled(Box)`
    ${({ theme }) => theme.mediaQueries.xs} {
        margin: 10px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        margin: 80px 0px 0px 50px;
        
    }
`

export const TermsandConditions = styled(NeedAnAccount)`
    ${({ theme }) => theme.mediaQueries.xs} {
        justify-content: start;
    }
`

export const ForgotPasswordPageHeight = styled(LoginBackgroundImage)`
    ${({ theme }) => theme.mediaQueries.xs} {
        min-height: 70vh;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        min-height: 74vh;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        min-height: 70vh;
    }
`

export const ForgotPasswordBoxSize = styled(LoginBackgroundFormBox)`
    ${({ theme }) => theme.mediaQueries.xs} {
        height: 600px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        height: 400px;
    }
`
export const FormBoxWrapper = styled(Flex)`
    width: 100%;
    position: absolute;
    height: 100vh;
    ${({ theme }) => theme.mediaQueries.xs} {
        flex-direction: column;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        flex-direction: row;
    }
`

export const FormImgBox = styled(Flex)`
    ${({ theme }) => theme.mediaQueries.xs} {
        width: 100%;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        width: 50%;
    }
`
export const FormRemoteStyle = styled(Box)`
    // background-image: url(${RemoteImg});
    background-image: url("newAssets/Hero/RemoteImg.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    ${({ theme }) => theme.mediaQueries.xs} {
        height: 346px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        height: 730px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        // height: auto;
    }
`
export const FormGamesfiStyle = styled(Flex)`
    justify-content: center;
    align-items: center;
    ${({ theme }) => theme.mediaQueries.xs} {
        margin-top: 15px;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        margin-top: 100px;
    }
    ${({ theme }) => theme.mediaQueries.md} {
        margin-top: 125px;
    }
`
export const FormBoxHeading = styled(Text)`
    color: ${(props) => props.theme.colors.textSubtle};
    font-weight: 900;
    ${({ theme }) => theme.mediaQueries.xs} {
        font-size: 24px;
        text-align: center;
    }
    ${({ theme }) => theme.mediaQueries.sm} {
        font-size: 36px;
    }
`
export const EmailVerificationBody = styled(Box)`
    width: 100%;
    height: 100vh;
    background-image: url(${HeroBackgroundBody});
    background-size: cover;
    background-position: bottom;
    background-repeat: no-repeat;
`
export const EmailVerificationWrapper = styled(Box)`
    width: 100%;
    height: 100vh;
    background-image: url(${HeroBackgroundWrapper});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    ${Flex}{
        justify-content: center;
        align-items: center;
        flex-direction: column;
        height: 100vh;
    }
    ${Text}{
        font-weight: 800;
        margin: 15px 0px;
    }
    & h5{
        font-weight: 500;
        font-size: 18px;
        color: ${(props) => props.theme.colors.text};
    }
    & p{
        font-weight: 400;
        font-size: 16px;
        color: ${(props) => props.theme.colors.gamefiSubHeadingColor};
        margin: 10px 0px 50px 0px;
    }
`